import React, { useEffect, useState } from "react";
import { Table, Modal, Badge, Card } from "react-bootstrap";
import axios from "axios";
import { FaMapMarkerAlt, FaCubes } from "react-icons/fa";

function BasicExample() {
  const [sortedClientiData, setSortedClientiData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "valore",
    direction: "descending",
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");

        if (!res.data?.AR?.localita) return;

        const clientiData = res.data.AR.localita || [];
        const lastMinuti = res.data.AR.lastminuti || [];
        const today = new Date().toISOString().split("T")[0];

        const expressMap = lastMinuti.reduce((acc, lm) => {
          if (!lm.ordinato) return acc;

          const dataOrdine = lm.data_ordine?.split(" ")[0];

          if (dataOrdine !== today) return acc;

          const key = `${lm.codice_cliente}-${lm.origine || "noweb"}`;
          const valore = parseFloat(lm.ordinato.replace(",", ".")) || 0;

          acc[key] = (acc[key] || 0) + valore;

          return acc;
        }, {});

        const transformedData = clientiData.reduce((acc, item) => {
          const id = item.id_cliente;
          const origine = item.origine || "noweb";
          const key = `${id}-${origine}`;
          const valore = parseFloat(item.Valore?.replace(",", ".")) || 0;

          if (!acc[key]) {
            acc[key] = {
              id_cliente: id,
              cliente: item.clienti,
              valore: 0,
              express: 0,
              regular: 0,
              numero: 0,
              localita: item.regione || item.nazione || item.paese,
              origine,
              dettagli: {},
            };
          }

          acc[key].valore += valore;
          acc[key].numero += Number(item.numero_doc || 0);

          const marchio = item.descrizione || "Generico";

          acc[key].dettagli[marchio] =
            (acc[key].dettagli[marchio] || 0) + valore;

          return acc;
        }, {});

        Object.values(transformedData).forEach((cliente) => {
          const key = `${cliente.id_cliente}-${cliente.origine}`;
          const express = expressMap[key] || 0;

          cliente.express = Math.min(express, cliente.valore);
          cliente.regular = cliente.valore - cliente.express;

          cliente.dettagli = Object.entries(cliente.dettagli)
            .map(([marchio, totaleMarchio]) => ({
              descrizione: marchio,
              valore: totaleMarchio,
            }))
            .sort((a, b) => b.valore - a.valore);
        });

        setSortedClientiData(
          sortArray(
            Object.values(transformedData),
            sortConfig.key,
            sortConfig.direction,
          ),
        );
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [sortConfig]);

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      const aValue = a[key] ?? 0;
      const bValue = b[key] ?? 0;

      if (typeof aValue === "number") {
        return direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      }

      return direction === "ascending"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction:
        sortConfig.key === key && sortConfig.direction === "ascending"
          ? "descending"
          : "ascending",
    });
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  return (
    <>
      {/* =====================================================
          TABELLA CLIENTI
          ===================================================== */}

      <Card
        className="card bg-dark ombra ordini-ora card-home hover-effect border-0 am-data-card am-clients-card"
        style={{ borderRadius: "15px", padding: "1.2rem" }}
      >
        <div
          className="no-scrollbar am-table-scroll"
          style={{
            width: "100%",
            position: "relative",
          }}
        >
          <Table
            hover
            variant="dark"
            className="mb-0 custom-table am-client-table"
            style={{
              fontSize: "0.8rem",
              width: "100%",
              margin: 0,
              borderCollapse: "separate",
            }}
          >
            <thead className="sticky-top" style={{ zIndex: 10 }}>
              <tr
                className="text-light small bg-dark"
                style={{ borderBottom: "2px solid #333" }}
              >
                <th className="ps-3 py-3 border-0 bg-dark text-light am-col-cliente">
                  CLIENTE
                </th>

                <th
                  style={{ width: "20%" }}
                  className="py-3 border-0 cursor-pointer bg-dark text-light am-hide-mobile am-col-localita"
                  onClick={() => handleSort("localita")}
                >
                  LOCALITÀ
                </th>

                <th
                  className="py-3 bg-dark fw-bold border-0 text-end am-col-valore"
                  style={{
                    color: "rgba(241,111,36,1)",
                    width: "25%",
                  }}
                  onClick={() => handleSort("valore")}
                >
                  VALORE
                </th>

                <th
                  style={{ width: "12%" }}
                  className="py-3 border-0 text-center bg-dark text-light am-col-ordini"
                >
                  ORDINI
                </th>

                <th
                  style={{ width: "18%" }}
                  className="py-3 border-0 text-center pe-3 bg-dark text-light am-col-origine"
                >
                  ORIGINE
                </th>
              </tr>
            </thead>

            <tbody>
              {sortedClientiData.map((item, index) => (
                <tr
                  key={`${item.id_cliente}-${item.origine}-${index}`}
                  onClick={() => {
                    setSelectedCliente(item);
                    setShowModal(true);
                  }}
                  className="cursor-pointer align-middle"
                >
                  <td className="ps-3 fw-bold bg-dark text-light truncate-cell am-col-cliente">
                    {item.cliente}
                  </td>

                  <td
                    className="bg-dark text-light truncate-cell am-hide-mobile am-col-localita"
                    style={{ fontSize: "0.75rem" }}
                  >
                    {item.localita}
                  </td>

                  <td
                    className="text-end bg-dark fw-bold am-col-valore"
                    style={{ color: "rgba(241,111,36,1)" }}
                  >
                    {formatToEuro(item.valore)}
                  </td>

                  <td className="text-center bg-dark text-light am-col-ordini">
                    <span className="bg-dark text-light">
                      {item.numero}
                    </span>
                  </td>

                  <td className="text-center bg-dark text-light pe-3 am-col-origine">
                    <Badge pill className="am-origin-badge">
                      {item.origine.toUpperCase()}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* =====================================================
          MODALE CLIENTE - LIQUID GLASS AMOTIVE
          ===================================================== */}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="am-client-modal"
        dialogClassName="am-client-modal-dialog"
        contentClassName="am-client-modal-content"
        backdropClassName="am-client-modal-backdrop"
      >
        <Modal.Header closeButton className="am-client-modal-header border-0">
          <Modal.Title className="d-flex align-items-center w-100">
            <div className="am-client-modal-icon">
              <FaCubes size={20} />
            </div>

            <div className="am-client-modal-heading">
              <div className="am-client-modal-name">
                {selectedCliente?.cliente}
              </div>

              <div className="am-client-modal-location">
                <FaMapMarkerAlt />

                <span>
                  {selectedCliente?.localita}
                </span>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="am-client-modal-body">
          <div className="am-client-modal-meta">
            <Badge pill className="am-modal-id-badge">
              ID {selectedCliente?.id_cliente}
            </Badge>

            <Badge pill className="am-origin-badge am-origin-badge-modal">
              {selectedCliente?.origine?.toUpperCase()}
            </Badge>
          </div>

          <div className="am-client-modal-kpis">
            <div className="am-client-kpi">
              <span>VALORE CLIENTE</span>

              <strong>
                {formatToEuro(selectedCliente?.valore)}
              </strong>
            </div>

            <div className="am-client-kpi">
              <span>ORDINI</span>

              <strong>
                {selectedCliente?.numero || 0}
              </strong>
            </div>
          </div>

          <div className="am-client-detail-panel">
            <div className="am-client-detail-header">
              <div>
                <small>DETTAGLIO ORDINI</small>
                <strong>Performance per brand</strong>
              </div>

              <span>
                {selectedCliente?.dettagli?.length || 0} brand
              </span>
            </div>

            <div className="am-client-detail-scroll">
              <Table hover className="mb-0 am-client-detail-table">
                <thead>
                  <tr>
                    <th>BRAND</th>

                    <th className="text-end">
                      VALORE
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {selectedCliente?.dettagli?.map((d, i) => (
                    <tr key={i}>
                      <td>
                        <strong>
                          {d.descrizione}
                        </strong>
                      </td>

                      <td className="text-end">
                        <strong className="am-detail-value">
                          {formatToEuro(d.valore)}
                        </strong>
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <td>
                      TOTALE
                    </td>

                    <td className="text-end">
                      {formatToEuro(selectedCliente?.valore)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* =====================================================
          STILE LOCALE
          ===================================================== */}

      <style>{`
        /* -----------------------------------------------------
           TABELLA PRINCIPALE
           ----------------------------------------------------- */

        .am-client-table {
          width: 100% !important;
          margin: 0 !important;
        }

        .am-client-table .truncate-cell {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 150px;
        }

        .am-client-table .cursor-pointer {
          cursor: pointer;
        }

        .am-client-table tbody tr:hover td {
          background:
            rgba(255, 255, 255, 0.035) !important;
        }

        /* Badge ORIGINE: sempre Amotive orange */
        .am-origin-badge {
          display: inline-flex !important;
          align-items: center;
          justify-content: center;

          min-width: 42px;

          padding:
            4px
            8px !important;

          color:
            #ff9a60 !important;

          background:
            linear-gradient(
              135deg,
              rgba(241, 111, 36, 0.20),
              rgba(241, 111, 36, 0.08)
            ) !important;

          border:
            1px solid
            rgba(241, 111, 36, 0.36) !important;

          border-radius:
            999px !important;

          box-shadow:
            inset 0 1px 0
            rgba(255, 255, 255, 0.06) !important;

          font-size:
            0.60rem !important;

          font-weight:
            850 !important;

          letter-spacing:
            0.035em;
        }

        /* -----------------------------------------------------
           BACKDROP OPACO
           ----------------------------------------------------- */

        .am-client-modal-backdrop.show {
          opacity:
            0.88 !important;

          background:
            #07090d !important;

          backdrop-filter:
            none !important;

          -webkit-backdrop-filter:
            none !important;
        }

        /* -----------------------------------------------------
           DIALOG
           ----------------------------------------------------- */

        .am-client-modal-dialog {
          width:
            min(
              780px,
              calc(100vw - 32px)
            ) !important;

          max-width:
            780px !important;

          margin:
            16px auto !important;
        }

        .am-client-modal-content {
          position: relative;

          max-height:
            calc(100dvh - 32px);

          overflow: hidden;

          color:
            #f5f6f8 !important;

          background:
            radial-gradient(
              circle at 0% 0%,
              rgba(241, 111, 36, 0.18),
              transparent 34%
            ),
            radial-gradient(
              circle at 100% 8%,
              rgba(255, 255, 255, 0.045),
              transparent 28%
            ),
            linear-gradient(
              145deg,
              rgba(39, 42, 49, 0.94),
              rgba(20, 22, 27, 0.97)
            ) !important;

          border:
            1px solid
            rgba(255, 255, 255, 0.11) !important;

          border-radius:
            24px !important;

          box-shadow:
            0 32px 80px
              rgba(0, 0, 0, 0.58),
            inset
              0 1px 0
              rgba(255, 255, 255, 0.09) !important;

          backdrop-filter:
            blur(8px)
            saturate(115%);

          -webkit-backdrop-filter:
            blur(8px)
            saturate(115%);
        }

        /* Riflesso arancione */
        .am-client-modal-content::before {
          content: "";

          position: absolute;

          top: 0;
          left: 24px;

          width: 42%;
          height: 1px;

          background:
            linear-gradient(
              90deg,
              #f16f24,
              transparent
            );

          pointer-events: none;

          z-index: 3;
        }

        /* -----------------------------------------------------
           HEADER
           ----------------------------------------------------- */

        .am-client-modal-header {
          padding:
            20px
            22px
            13px !important;

          background:
            transparent !important;

          border-bottom:
            1px solid
            rgba(255, 255, 255, 0.06) !important;
        }

        .am-client-modal-icon {
          flex:
            0 0
            44px;

          width:
            44px;

          height:
            44px;

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          margin-right:
            12px;

          color:
            #ff8847;

          background:
            linear-gradient(
              145deg,
              rgba(241, 111, 36, 0.22),
              rgba(241, 111, 36, 0.08)
            );

          border:
            1px solid
            rgba(241, 111, 36, 0.30);

          border-radius:
            14px;

          box-shadow:
            inset 0 1px 0
            rgba(255, 255, 255, 0.055);
        }

        .am-client-modal-heading {
          min-width:
            0;
        }

        .am-client-modal-name {
          max-width:
            100%;

          overflow:
            hidden;

          color:
            #fff;

          font-size:
            1.15rem;

          font-weight:
            850;

          line-height:
            1.15;

          text-overflow:
            ellipsis;

          white-space:
            nowrap;
        }

        .am-client-modal-location {
          display:
            flex;

          align-items:
            center;

          gap:
            5px;

          margin-top:
            5px;

          color:
            rgba(
              255,
              255,
              255,
              0.48
            );

          font-size:
            0.72rem;

          font-weight:
            650;
        }

        .am-client-modal-location svg {
          color:
            #f16f24;
        }

        .am-client-modal-content .btn-close {
          width:
            34px;

          height:
            34px;

          margin:
            0 !important;

          padding:
            0 !important;

          border-radius:
            50%;

          background-color:
            rgba(
              255,
              255,
              255,
              0.075
            );

          background-size:
            11px;

          filter:
            invert(1)
            grayscale(1);

          opacity:
            0.75;
        }

        .am-client-modal-content .btn-close:hover {
          opacity:
            1;

          background-color:
            rgba(
              241,
              111,
              36,
              0.17
            );
        }

        /* -----------------------------------------------------
           BODY
           ----------------------------------------------------- */

        .am-client-modal-body {
          padding:
            10px
            22px
            22px !important;

          overflow-y:
            auto;

          background:
            transparent !important;

          scrollbar-width:
            none !important;

          -ms-overflow-style:
            none !important;
        }

        .am-client-modal-body::-webkit-scrollbar {
          display:
            none !important;

          width:
            0 !important;

          height:
            0 !important;
        }

        /* -----------------------------------------------------
           META
           ----------------------------------------------------- */

        .am-client-modal-meta {
          display:
            flex;

          flex-wrap:
            wrap;

          gap:
            7px;

          margin-bottom:
            12px;
        }

        .am-modal-id-badge {
          padding:
            5px
            9px !important;

          color:
            rgba(
              255,
              255,
              255,
              0.62
            ) !important;

          background:
            rgba(
              255,
              255,
              255,
              0.055
            ) !important;

          border:
            1px solid
            rgba(
              255,
              255,
              255,
              0.085
            ) !important;

          font-size:
            0.60rem !important;

          font-weight:
            750 !important;
        }

        .am-origin-badge-modal {
          min-width:
            auto;
        }

        /* -----------------------------------------------------
           KPI
           ----------------------------------------------------- */

        .am-client-modal-kpis {
          display:
            grid;

          grid-template-columns:
            minmax(0, 1fr)
            150px;

          gap:
            10px;

          margin-bottom:
            12px;
        }

        .am-client-kpi {
          padding:
            12px
            14px;

          background:
            linear-gradient(
              145deg,
              rgba(255, 255, 255, 0.055),
              rgba(255, 255, 255, 0.025)
            );

          border:
            1px solid
            rgba(
              255,
              255,
              255,
              0.075
            );

          border-radius:
            14px;

          box-shadow:
            inset 0 1px 0
            rgba(
              255,
              255,
              255,
              0.035
            );
        }

        .am-client-kpi span {
          display:
            block;

          margin-bottom:
            4px;

          color:
            rgba(
              255,
              255,
              255,
              0.36
            );

          font-size:
            0.56rem;

          font-weight:
            850;

          letter-spacing:
            0.075em;
        }

        .am-client-kpi strong {
          display:
            block;

          color:
            #fff;

          font-size:
            1rem;

          font-weight:
            850;
        }

        /* -----------------------------------------------------
           DETAIL PANEL
           ----------------------------------------------------- */

        .am-client-detail-panel {
          overflow:
            hidden;

          background:
            rgba(
              8,
              10,
              13,
              0.24
            );

          border:
            1px solid
            rgba(
              255,
              255,
              255,
              0.075
            );

          border-radius:
            16px;
        }

        .am-client-detail-header {
          display:
            flex;

          align-items:
            center;

          justify-content:
            space-between;

          gap:
            12px;

          padding:
            11px
            13px;

          border-bottom:
            1px solid
            rgba(
              255,
              255,
              255,
              0.06
            );
        }

        .am-client-detail-header > div {
          display:
            flex;

          flex-direction:
            column;
        }

        .am-client-detail-header small {
          color:
            rgba(
              255,
              255,
              255,
              0.34
            );

          font-size:
            0.53rem;

          font-weight:
            850;

          letter-spacing:
            0.08em;
        }

        .am-client-detail-header strong {
          margin-top:
            2px;

          color:
            rgba(
              255,
              255,
              255,
              0.86
            );

          font-size:
            0.76rem;
        }

        .am-client-detail-header > span {
          color:
            rgba(
              255,
              255,
              255,
              0.40
            );

          font-size:
            0.63rem;

          font-weight:
            700;
        }

        /* -----------------------------------------------------
           TABELLA MODALE SCROLLABILE SENZA BARRA
           ----------------------------------------------------- */

        .am-client-detail-scroll {
          max-height:
            360px;

          overflow-y:
            auto;

          overflow-x:
            auto;

          scrollbar-width:
            none !important;

          -ms-overflow-style:
            none !important;

          overscroll-behavior:
            contain;
        }

        .am-client-detail-scroll::-webkit-scrollbar {
          display:
            none !important;

          width:
            0 !important;

          height:
            0 !important;
        }

        .am-client-detail-table {
          width:
            100%;

          margin:
            0 !important;

          color:
            rgba(
              255,
              255,
              255,
              0.70
            ) !important;

          background:
            transparent !important;
        }

        .am-client-detail-table
        > :not(caption)
        > *
        > * {
          background:
            transparent !important;

          box-shadow:
            none !important;
        }

        .am-client-detail-table thead th {
          position:
            sticky;

          top:
            0;

          z-index:
            3;

          padding:
            9px
            13px !important;

          color:
            rgba(
              255,
              255,
              255,
              0.38
            ) !important;

          background:
            #191c21 !important;

          border:
            0 !important;

          border-bottom:
            1px solid
            rgba(
              255,
              255,
              255,
              0.065
            ) !important;

          font-size:
            0.57rem;

          font-weight:
            850;

          letter-spacing:
            0.075em;
        }

        .am-client-detail-table tbody td {
          padding:
            10px
            13px !important;

          color:
            rgba(
              255,
              255,
              255,
              0.72
            ) !important;

          border:
            0 !important;

          border-bottom:
            1px solid
            rgba(
              255,
              255,
              255,
              0.045
            ) !important;
        }

        .am-client-detail-table
        tbody
        tr:hover
        td {
          background:
            rgba(
              255,
              255,
              255,
              0.035
            ) !important;
        }

        .am-client-detail-table
        tbody
        td:first-child
        strong {
          color:
            rgba(
              255,
              255,
              255,
              0.88
            );
        }

        .am-detail-value {
          color:
            #ff8847;
        }

        .am-client-detail-table tfoot td {
          padding:
            12px
            13px !important;

          color:
            #fff !important;

          background:
            rgba(
              241,
              111,
              36,
              0.10
            ) !important;

          border:
            0 !important;

          font-size:
            0.78rem;

          font-weight:
            850;
        }

        .am-client-detail-table
        tfoot
        td:last-child {
          color:
            #ff8847 !important;
        }

        /* -----------------------------------------------------
           MOBILE
           ----------------------------------------------------- */

        @media screen and (max-width: 767px) {
          .am-client-modal-dialog {
            width:
              calc(
                100vw - 14px
              ) !important;

            max-width:
              none !important;

            margin:
              7px auto !important;
          }

          .am-client-modal-content {
            max-height:
              calc(
                100dvh - 14px
              );

            border-radius:
              19px !important;
          }

          .am-client-modal-header {
            padding:
              16px
              15px
              10px !important;
          }

          .am-client-modal-body {
            padding:
              8px
              15px
              15px !important;
          }

          .am-client-modal-icon {
            flex-basis:
              38px;

            width:
              38px;

            height:
              38px;

            border-radius:
              12px;
          }

          .am-client-modal-name {
            font-size:
              0.98rem;
          }

          .am-client-modal-kpis {
            grid-template-columns:
              minmax(0, 1fr)
              100px;

            gap:
              7px;
          }

          .am-client-kpi {
            padding:
              10px;
          }

          .am-client-kpi strong {
            font-size:
              0.88rem;
          }

          .am-client-detail-scroll {
            max-height:
              43vh;
          }

          .am-client-detail-table
          thead
          th,
          .am-client-detail-table
          tbody
          td,
          .am-client-detail-table
          tfoot
          td {
            padding:
              9px
              10px !important;
          }
        }
      `}</style>
    </>
  );
}

export default BasicExample;
